import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-782aaefe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "badge bg-primary rounded-pill d-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recursive_taxonomy_buttons = _resolveComponent("recursive-taxonomy-buttons", true)!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tax.items, (item) => {
    return (_openBlock(), _createElementBlock("span", {
      class: _normalizeClass('button-group rtb-grp' + (_ctx.groupClass ? ' ' + _ctx.groupClass : '')),
      key: item.id
    }, [
      (item.count > 0 && (null === _ctx.showTerms || _ctx.showTerms.includes(item.id)))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["btn btn-sm btn-outline-white rounded-0 m-1", { active: _ctx.activeTermIds.includes(item.id) }]),
            onClick: ($event: any) => (_ctx.updateTaxonomy(_ctx.slug, item.id))
          }, [
            _createTextVNode(_toDisplayString(item.name) + " ", 1),
            (item.count)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.count), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_1))
        : _createCommentVNode("", true),
      (item.items)
        ? (_openBlock(), _createBlock(_component_recursive_taxonomy_buttons, {
            key: 1,
            ref_for: true,
            ref: "recursiveTaxonomyButtons",
            tax: item,
            slug: _ctx.slug,
            groupClass: "border-0",
            onUpdateTaxonomy: _ctx.updateTaxonomy,
            "multi-select": _ctx.multiSelect
          }, null, 8, ["tax", "slug", "onUpdateTaxonomy", "multi-select"]))
        : _createCommentVNode("", true)
    ], 2))
  }), 128))
}